@if(table) {
<cac-table [options]="table" class="selectable-table">
    @if(mode() === 'property') {
    <ng-container slot="header-start">
        <app-import type="property" [internalImport]="true" (refresh)="onRefresh()" permission="ImportProperties"></app-import>
    </ng-container>
    }
</cac-table>
}